import { SimilarRequest, SimilarRequestsResponse } from '../services/similarRequestsService';
import './SimilarRequestsSidebar.css';

interface SimilarRequestsSidebarProps {
  isOpen: boolean;
  onToggle: () => void;
  similarRequestsData?: SimilarRequestsResponse | null;
  loading?: boolean;
}


const SimilarRequestsSidebar = ({
  isOpen,
  onToggle,
  similarRequestsData,
  loading = false,
}: SimilarRequestsSidebarProps) => {
  const similarRequests = similarRequestsData?.similar_requests || [];

  return (
    <>
      {/* Overlay */}
      {isOpen && <div className="sidebar-overlay" onClick={onToggle} />}

      {/* Sidebar */}
      <div className={`similar-requests-sidebar ${isOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <h2 className="sidebar-title">
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" width="20" height="20" strokeWidth={2}>
              <path d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
            </svg>
            Related Requests
          </h2>
          <button className="sidebar-close" onClick={onToggle} aria-label="Close sidebar">
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" width="20" height="20">
              <path d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <div className="sidebar-content">
          <div className="requests-list">
            {loading ? (
              <div className="loading-state">
                <svg className="loading-spinner" fill="none" stroke="currentColor" viewBox="0 0 24 24" width="20" height="20">
                  <path d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                </svg>
                <span>Loading similar requests...</span>
              </div>
            ) : similarRequests.length > 0 ? (
              similarRequests.map((request) => (
                <div key={request.id || request.gid} className="request-item" onClick={() => console.log('🔗 Opening request:', request.title)}>
                  <div className="request-header">
                    <h4 className="request-title">
                      {(request.link || request.permalink_url) ? (
                        <a href={request.link || request.permalink_url} target="_blank" rel="noopener noreferrer">
                          {request.title}
                        </a>
                      ) : (
                        request.title
                      )}
                    </h4>
                  </div>

                  <div className="request-meta">
                    <span className="request-team">{request.team || 'Unknown Team'}</span>
                    <span className="request-date">
                      {new Date(request.created_at).toLocaleDateString(undefined, {
                        year: 'numeric',
                        month: 'short',
                        day: 'numeric',
                      })}
                    </span>
                    {request.target_year && (
                      <span className="request-target-year">Target: {request.target_year}</span>
                    )}
                  </div>
                </div>
              ))
            ) : (
              <div className="empty-state">
                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" width="24" height="24">
                  <path d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
                <span>No similar requests found</span>
                <small>Start a conversation to see related requests</small>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default SimilarRequestsSidebar;
